export class WorkFlow {
    WorkFlowId: number = 0;
    WorkFlowName: string;
    WorkFlowDescription: string;
    WorkFlowStation: string;
    UserId: string;
}